import { forwardRef, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { LayoutContext } from './context/layoutcontext';
import { getSettings } from '../../Helpers/SettingsHelper';
import { Paths } from '../../Common/Paths';
import { AppTopbarRef } from '../../Models/Template/index'
import { StyleClass } from 'primereact/styleclass';
import { SCIcon, Ripple } from '../../Common/Imports';
import { useAxios } from '../../Helpers/AxiosHelper';
import { ApiResponse, ReservationCommunications_EXT } from '../../Models/Classes';
import { PermissionHelper, usePermissions } from '../../Helpers/Permissions/PermissionContext';

const AppTopbar = forwardRef<AppTopbarRef>(() => {
    const P_ShowMailNotifications = { idAspNetRole: usePermissions().userRole, idItem: "0", idPermission: 11 };
    const { onMenuToggle, onTopbarMenuToggle } = useContext(LayoutContext);
    const menubuttonRef = useRef<HTMLAnchorElement>(null);
    const mobileButtonRef = useRef<HTMLAnchorElement>(null);
    const bellRef = useRef(null);
    const config = getSettings();
    const AxiosHelper = useAxios();
    const [TotalMail, setTotalMail] = useState<number>(0);
    const [MailInbox, setTotalMailInbox] = useState<number>(0);
    const [Mail, setMail] = useState<number>(0);

    const onMenuButtonClick = () => {
        onMenuToggle();
    };

    const onMobileTopbarMenuButtonClick = () => {
        onTopbarMenuToggle();
    };

    const GetData = useCallback(async () => {
        try {
            const resp = await AxiosHelper.get<ApiResponse<ReservationCommunications_EXT[]>>(`Layout/GetUnriddenComunications`);
            if (resp.data.code === 0) {
                setMail(resp.data.data.length - 1);
            }
            const resp2 = await AxiosHelper.get<ApiResponse<number>>(`Layout/GetUnriddenEmail`);
            if (resp2.data.code === 0) {
                setTotalMailInbox(resp2.data.data);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, [AxiosHelper]);

    useEffect(() => {
        setTotalMail(Mail + MailInbox);
    }, [Mail, MailInbox]);

    useEffect(() => {
        GetData();
    }, [GetData]);

    return (
        <div className="layout-topbar">
            <div className="layout-topbar-start">
                <a ref={menubuttonRef} className="p-ripple layout-menu-button" onClick={onMenuButtonClick}>
                    <SCIcon Classes="" Name="Menu" />
                    <Ripple />
                </a>
                <a ref={mobileButtonRef} className="p-ripple layout-topbar-mobile-button" onClick={onMobileTopbarMenuButtonClick}>
                    <SCIcon Classes="" Name="Menu" />
                    <Ripple />
                </a>
                <Link className="layout-topbar-logo" to="/">
                    <img src={config.settings.cdnUrl + Paths.LogoFull.value} alt="logo" />
                </Link>
            </div>
            <div className="layout-topbar-end">
                <div className="layout-topbar-actions-end">
                    <ul className="layout-topbar-items">
                        <PermissionHelper requiredPermission={P_ShowMailNotifications}>
                            <li>
                                <StyleClass
                                    nodeRef={bellRef}
                                    selector="@next"
                                    enterClassName="hidden"
                                    enterActiveClassName="px-scalein"
                                    leaveToClassName="hidden"
                                    leaveActiveClassName="px-fadeout"
                                    hideOnOutsideClick
                                >
                                    <a className="p-ripple" ref={bellRef}>
                                        <SCIcon Name="Mail" Count={TotalMail} />
                                        <Ripple />
                                    </a>
                                </StyleClass>
                                <div className="hidden">
                                    <ul className="list-none p-0 m-0">
                                        <li>
                                            <a href={Paths["Mail"].value} className="py-2 px-3 flex gap-2 cursor-pointer text-color hover:text-primary">
                                                <div className="col-md-2">
                                                    <b style={{ color: "red" }}>{MailInbox}</b>
                                                </div>
                                                <div className="col-md-10">
                                                    <span>Unread Mail (Mailbox)</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a href={Paths["OperativeListUnreadEmails"].value} className="py-2 px-3 flex gap-2 cursor-pointer text-color hover:text-primary">
                                                <div className="col-md-2">
                                                    <b style={{ color: "red" }}>{Mail}</b>
                                                </div>
                                                <div className="col-md-10">
                                                    <span>Unread Mail</span>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </PermissionHelper>
                    </ul>
                </div>
            </div>
        </div>
    );
});

AppTopbar.displayName = 'AppTopbar';

export default AppTopbar;